// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"71":"1c191ff4","169":"becc8776"}[chunkId] + ".js";
};